import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=5d31da68&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=5d31da68&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d31da68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d31da68')) {
      api.createRecord('5d31da68', component.options)
    } else {
      api.reload('5d31da68', component.options)
    }
    module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=5d31da68&scoped=true", function () {
      api.rerender('5d31da68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/footer-pages/privacy-policy/PrivacyPolicy.vue"
export default component.exports